<template>
    <v-card :loading="loading">
        <template slot="progress">
            <v-progress-linear color="deep-purple" height="10" indeterminate></v-progress-linear>
        </template>

        <v-card-title class="mb-1 pb-1 blue--text text--darken-3">
            {{ RoomRate.hotDealName }}
        </v-card-title>

        <v-card-text class="mb-0  pb-0">
            <v-row class="mx-0" no-gutters>
                <v-col md="4">

                    <v-carousel hide-delimiters height="250" width="250">

                        <v-carousel-item v-if="RoomRate.roomImages.length !== 0"
                            v-for="(item, i) in RoomRate.roomImages" :key="i" :src="item.urlImage"
                            reverse-transition="fade-transition" transition="fade-transition"></v-carousel-item>

                        <v-carousel-item v-if="RoomRate.roomImages.length === 0">
                            <v-sheet color="gray" height="100%">
                                <v-row class="fill-height" align="center" justify="center">
                                    <div class="text-h2">
                                        No Image
                                    </div>
                                </v-row>
                            </v-sheet>
                        </v-carousel-item>


                    </v-carousel>
                </v-col>

                <v-col md="8">
                    <v-row no-gutters>
                        <v-col class="mx-2 px-2">
                            <div>{{ hotDealDescription }}</div>
                        </v-col>
                        <v-col>
                            <div class="d-flex justify-center text-subtitle-2 font-weight-black">
                                Start From
                            </div>
                            <div
                                class="d-flex justify-center text-subtitle-2 font-weight-black text-decoration-line-through deep-orange--text text--darken-2">
                                <strong>{{ RoomRate.roomRatePlans[0].displayOriginalPrice }}</strong>
                            </div>
                            <div class="d-flex justify-center text-h6 teal--text text--darken-1">
                                <strong>{{ RoomRate.roomRatePlans[0].displayTotalPrice }}</strong>
                            </div>
                            <div class="d-flex justify-center ">
                                Price for {{ RoomRate.roomRatePlans[0].priceList.length }} night(s)
                            </div>

                            <template v-if="RoomRate.roomRatePlans[0].promotionType !== 'None'">
                                <div class="d-flex justify-center text-h6">
                                    <v-icon class="red--text darken-2">mdi-star</v-icon> Promotion
                                </div>
                            </template>
                            <!-- <div class="d-flex justify-center text-h6">
                                <v-icon class="red--text darken-2">mdi-gift</v-icon> Package Deal
                            </div> -->


                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card-text>

        <!-- <v-divider class="mx-4"></v-divider> -->

        <!-- <v-card-title>Unit</v-card-title> -->

        <!-- <v-card-text>
  
        <v-select v-model="selectedUnit" :items="numberOfUnits" solo> </v-select>
      </v-card-text> -->

        <v-card-actions class="mt-0 pt-0 text-subtitle-2">
            <v-list min-width="100%">
                <v-list-item>
                    <v-row no-gutters>
                        <v-col>
                            <v-icon>mdi-account</v-icon>
                        </v-col>
                        <v-col>Rate Plan</v-col>
                        <v-col class="d-flex justify-center">Rates</v-col>
                        <v-col class="d-flex justify-center">
                            Room Available
                        </v-col>
                        <v-col class="d-flex justify-center">
                            Package Details
                        </v-col>
                        <v-col>
                        </v-col>
                    </v-row>
                </v-list-item>
                <template v-for="(ratePlan, iratePlan) in RoomRate.roomRatePlans">
                    <v-list-item :key="'vlist' + iratePlan">
                        <rate-plan :IsPackage="true" :Occupancy="numberOfUnits(ratePlan.room.availability)"
                            :RatePlan="ratePlan" :Room="RoomRate"></rate-plan>
                    </v-list-item>
                    <v-divider :key="'divider' + iratePlan"></v-divider>
                </template>

            </v-list>
        </v-card-actions>
    </v-card>
</template>
  
<script>
import moment from "moment";
import RatePlan from "./RatePlan.vue";
export default {
    props: {
        RoomRate: {
            type: Object,
            require: true,
        },
    },
    components: {
        RatePlan
    },
    data: () => ({
        loading: false,
        selection: 1,
        items: [],
        selectedUnit: 1,
        dialog: false,
    }),

    methods: {
        formatDate(date) {
            return moment(date).format("dddd Do MMMM");
        },
        numberOfUnits: function (availability) {
            let occupancy = availability;
            let list = [];
            for (let counter = 1; counter <= occupancy; counter++) {
                list.push({ text: `${counter} Unit`, value: counter });
            }

            return list;
        },
    },
    computed: {
        hotDealName: function () {
            let name = this.RoomRate.hotDealName;
            // let name = this.RoomRate.priceList[0].hotDealName;
            return name;
        },
        hotDealDescription: function () {
            let name = this.RoomRate.hotDealDescription;
            // let name = this.RoomRate.priceList[0].hotDealDescription;
            return name;
        },

    },
};
</script>